
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Congenital_HYP",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Congenital_HYP.vue